import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import Modal from "react-bootstrap/Modal";
import PopUp from "../../components/popUp";

function Trustedcompany(props) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <div className="trusted_company p-100">
        <Container>
          <Row>
            <Col
              xs={12}
              md={12}
              lg={6}
              xl={6}
              xxl={6}
              className="mt-3 mt-lg-0 order-2 order-md-1"
            >
              <p>
                TekRevol is a leading web development company in the UK,
                dedicated to elevating your brand through state-of-the-art,
                responsive web design that seamlessly adapts to a variety of
                devices, including laptops, smartphones, and tablets.
              </p>
              <p>
                As a premium web development company in the UK, our foremost
                goal is to create distinctive digital products with high-level
                functionality while elevating the brand’s image. Moreover, we
                prioritise your website's scalability, ensuring that it can be
                expanded and enhanced cost-effectively over time while
                maintaining optimal performance.
              </p>
              <p>
                What distinguishes our web development company in the UK is the
                unique fusion of business experts, design creativity, and
                technical proficiency. We achieve exceptional results through
                the development of functional and visually appealing designs,
                and the careful selection of the most suitable technologies
                considering a specific project.
              </p>
              <button
                style={{ background: "#F47a14", color: "#fff" }}
                onClick={handleShow}
                className="border_btn"
              >
                Let's Connect!
              </button>
            </Col>
            <Col
              xs={12}
              md={12}
              lg={6}
              xl={6}
              xxl={6}
              className="order-1 order-md-2"
            >
              <h2>
                Reviving UK Businesses with Our <span>Next-Gen Web Design</span>{" "}
                and Development
              </h2>
              <div className="img_next_gen mt-3 mt-md-4">
                <StaticImage
                  src="../../../images/location_new/uk-web/uk_next_gen.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={802}
                  height={427}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-popup"
      >
        <div className="modal_forms">
          <PopUp setShow={setShow} />
        </div>
      </Modal>
    </>
  );
}

export default Trustedcompany;
